var _defs, _g, _rect, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": " \\uB808\\uC774\\uC5B4 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1980 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #161619;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1121.1,0C1120.1,0,1119.2,0,1118.2,0,1118,0,1117.9,0,1117.8,0h-59C1048.7,0,1040.4,9.9,1040.4,22v556c0,12.2,8.2,22,18.4,22h59c.1,0,.2,0,.4,0,1,0,2,0,3,0,138.6,0,250.9-134.3,250.9-300S1259.7,0,1121.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1050,600c1,0,2,0,3,0,.1,0,.2,0,.4,0h58.1c10.2,0,18.4-9.8,18.4-22V22C1129.8,9.9,1121.5,0,1111.4,0h-58.1c-.1,0-.2,0-.4,0C1051.9,0,1050.9,0,1050,0,911.4,0,799,134.3,799,300s112.3,300,250.9,300Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 554.4,
    y: -2.5,
    width: 183.9,
    height: 604.9,
    rx: 20,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.7,300h0c82.8,0,150-67.2,150-150S426.5,0,343.7,0H16.3C5.2,0-3.7,8.9-3.7,20v560c0,11,8.9,20,20,20h327.4c82.8,0,150-67.2,150-150s-67.2-150-150-150Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1689.4.4c-148.6,15.2-264.6,143.3-264.6,299.2h294.1s0-275,0-275c0-14.5-13.8-25.8-29.6-24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1703,600.3c145.7,0,265.2-121.1,277.1-275.2,1.1-13.8-10.3-25.5-24.7-25.5h-530.6c0,166.1,124.5,300.7,278.1,300.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.6ab11bef95219e81f6a16b97875a2e0e.svg";
export { ForwardRef as ReactComponent };